var exports = {
  "Nr": "PlutoniumPageLinkCard.module__card___UVZUbW",
  "Kk": "PlutoniumPageLinkCard.module__icon___UVZUbW",
  "Qq": "PlutoniumPageLinkCard.module__text___UVZUbW",
  "DD": "PlutoniumPageLinkCard.module__title___UVZUbW",
  "rf": "PlutoniumPageLinkCard.module__body___UVZUbW",
};

module.exports = exports;
